<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import type {DatatypedFilterDefinition, FilterOperator} from '../../types';
    import {exists} from 'shared/utils/custom-utils';
    import {getSearchFieldTypeFiltersContext} from '../../search-field-type-filters.context';
    import {getFilterButtonsContext, FILTER_BY_DEFAULT_EVENT} from './filter-buttons.context';
    import {onDestroy, onMount} from 'svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let filterableDatatypeDefinition: DatatypedFilterDefinition;
    export let value: any;
    export let icon: UIcons;
    export let filterOperator: FilterOperator | null = null;
    export let defaultFilter = false;

    const context = getSearchFieldTypeFiltersContext();
    const filterButtonsContext = getFilterButtonsContext();

    onMount(() => {
        filterButtonsContext.eventBus.addEventListener(FILTER_BY_DEFAULT_EVENT, handleFilterByDefault);
    });

    onDestroy(() => {
        filterButtonsContext.eventBus.removeEventListener(FILTER_BY_DEFAULT_EVENT, handleFilterByDefault);
    })

    const handleFilterClick = () => {
        context.setFilteredValue(filterableDatatypeDefinition.fieldName, {
            val: value,
            datatype: filterableDatatypeDefinition.datatype.name,
            filterOperator: exists(filterOperator) ? filterOperator : undefined
        });
    };

    const handleFilterByDefault = () => {
        if (!defaultFilter || !exists(value)) {
            return;
        }

        handleFilterClick();
    };
</script>

<KpButton isDisabled={!exists(value)} buttonSize="sm" buttonStyle="primary" on:click={handleFilterClick}>
    <IconedContent {icon}>
        <slot/>
    </IconedContent>
</KpButton>